import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
    return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
    // Force theme to 'dark' since the toggle has been removed
    const [theme, setTheme] = useState('dark');

    useEffect(() => {
        // Persist to local storage
        localStorage.setItem('app-theme', theme);
        // Add data-theme attribute to html or body tag for CSS targeting
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
